import { render, staticRenderFns } from "./TencentyunCosUploadMultiImg.vue?vue&type=template&id=6fb698f1&scoped=true&"
import script from "./TencentyunCosUploadMultiImg.vue?vue&type=script&lang=js&"
export * from "./TencentyunCosUploadMultiImg.vue?vue&type=script&lang=js&"
import style0 from "./TencentyunCosUploadMultiImg.vue?vue&type=style&index=0&id=6fb698f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb698f1",
  null
  
)

export default component.exports